import { ICreateEmpreendimentoUseCase } from "../../../presentation/useCases/create/create_empreendimento_use_case";
import { EmpreendimentoCreate } from "../../models/empreendimentoCreate";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * CreateEmpreendimentoUseCase
 */

export class CreateEmpreendimentoUseCase implements ICreateEmpreendimentoUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }

  async createEmpreendimentoUsecase(createForm: EmpreendimentoCreate): Promise<number> {
    return await this.repository.createEmpreendimento(createForm);

  }
}
